<template>
    <v-card class="patient fill-height">
        <v-container>
            <v-form ref="physioForm" v-model="physioInfoValid" lazy-validation>

            <v-layout>
                <v-flex md10 offset-md1>
                    <h3 class="headline mb-4">Informations du physiothérapeute</h3>

                    <v-text-field v-model="name" :rules="nameRules" label="Nom" required></v-text-field>

                    <v-text-field :rules="emailRules"
                                  :value="email ? email.toLowerCase() : ''"
                                  @input="(value) => { setEmail(value.toLowerCase()) }"
                                  label="Email"></v-text-field>

                    <v-text-field v-model="phone" label="Téléphone"></v-text-field>


                    <v-text-field v-model="address" label="Adresse"></v-text-field>
                    <v-text-field v-model="postcode" label="Code postal"></v-text-field>
                    <v-text-field v-model="city" label="Ville"></v-text-field>
                    <v-select
                        :items="countryList"
                        v-model="country" label="Pays"
                        item-text="name"
                        item-value="name"
                    ></v-select>
                </v-flex>
            </v-layout>
            <v-layout>
                <v-flex md10 offset-md1 text-xs-right>
                    <v-btn :disabled="!physioInfoValid" color="success" @click="validate">Enregistrer
                    </v-btn>

                    <v-btn color="danger" flat @click="deleteDialog = true">
                        <v-icon>delete</v-icon> Supprimer
                    </v-btn>
                </v-flex>
            </v-layout>

        </v-form>

            <v-dialog v-model="deleteDialog" persistent max-width="480">
                <v-card>
                    <v-card-title class="headline">Supprimer le physiothérapeute</v-card-title>
                    <v-card-text>Voulez-vous vraiment supprimer le physiothérapeute ?
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" text @click="deleteDialog = false">Annuler</v-btn>
                        <v-btn color="primary" text @click="deletePhysio()">Oui, supprimer</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-container>
    </v-card>

</template>

<script>
import {mapActions, mapState, mapMutations, mapGetters} from 'vuex'
    import {getTranslationString} from "../../helper"
    import countries from "../../countries"

    export default {
        name: "PhysioForm",
        data() {
            return {
                mode: 'create',
                physioInfoValid: false,
                nameRules: [
                    v => !!v || 'Le nom est requis'
                ],
                emailRules: [
                    v => (!v || (/.+@.+\..+/.test(v))) || 'E-mail must be valid'
                ],
                deleteDialog: false
            }
        },
        computed: {
            countryList() {
                return countries
            },
            ...mapState('physios', {
                physiosList: state => state.physiosList
            }),
            name: {
                get() {
                    return this.$store.state.physios.form.name
                },
                set(value) {
                    this.setName(value)
                }
            },
            email: {
                get() {
                    return this.$store.state.physios.form.email
                },
                set(value) {
                    this.setEmail(value)
                }
            },
            phone: {
                get() {
                    return this.$store.state.physios.form.phone
                },
                set(value) {
                    this.setPhone(value)
                }
            },
            address: {
                get() {
                    return this.$store.state.physios.form.address
                },
                set(value) {
                    this.setAddress(value)
                }
            },
            postcode: {
                get() {
                    return this.$store.state.physios.form.postcode
                },
                set(value) {
                    this.setPostcode(value)
                }
            },
            city: {
                get() {
                    return this.$store.state.physios.form.city
                },
                set(value) {
                    this.setCity(value)
                }
            },
            country: {
                get() {
                    return this.$store.state.physios.form.country
                },
                set(value) {
                    this.setCountry(value)
                }
            },
        },
        created() {
            if (this.$route.params.id) {
                this.mode = "edit"

                this.setSelectedPhysioId(this.$route.params.id)
                this.loadPhysioForm()
            }
            else {
                this.mode = "create"
            }
        },
        mounted() {
            if (this.mode === 'create') {
                this.name = ''
                this.email = ''
                this.phone = ''
                this.address = ''
                this.postcode = ''
                this.city = ''
                this.country = 'Suisse'
            }
        },
        methods: {
            validate() {
                if (this.$refs.physioForm.validate()) {
                    this.submit()
                }
            },
            submit() {
                if (this.mode === 'create') {
                    this.createPhysio().then(response => {
                        this.$router.replace({name: 'physios'})
                    }).catch(reason => {
                        //Stay here..
                    })
                } else {
                    this.updatePhysio().then(response => {
                        this.$router.replace({name: 'physios'})
                    }).catch(reason => {
                        //Stay here..
                    })
                }
            },
            deletePhysio() {
                this.postDeletePhysio().then(response => {
                    this.$router.replace({name: 'physios'})
                }).catch(reason => {
                    //Stay here..
                })
            },
            ...mapMutations('physios', {
                setName: 'setFormName',
                setEmail: 'setFormEmail',
                setPhone: 'setFormPhone',
                setAddress: 'setFormAddress',
                setPostcode: 'setFormPostcode',
                setCity: 'setFormCity',
                setCountry: 'setFormCountry',
                setSelectedPhysioId: 'setSelectedPhysioId',
                initPhysioForms: 'initPhysioForms',
            }),
            ...mapActions('physios', ['createPhysio', 'updatePhysio', 'loadPhysioForm', 'postDeletePhysio'])
        },
        watch: {
        },
    }
</script>

<style scoped>

</style>
